module.exports = __webpack_public_path__ + "img/OBJECTS-2.3c105ffa.png";